import React, { useState } from 'react';
import { List, ListItem, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../../styles/SideBarListStyle';
import useFetchList from '../hooks/useFetchList';
import FloatButton from '../../sidebar/FloatButton';
import ShowProgress from '../../ui/Backdrop';
import { setLeaderboardId } from '../../../redux/actions/DealershipActions';
import LeaderboardAddNewPopup from './LeaderboardAddNewPopup';

const SidebarLeaderboard = ({ filterArray }) => {
  const dispatch = useDispatch();
  const selectedId = useSelector((state) => state?.getLeaderboard?.selectedLeaderboard);
  const { getOverview } = useFetchList();
  const classes = SideBarListStyles();

  const [isAddNewPopupOpen, setIsAddNewPopupOpen] = useState(false);

  const handleListItemClick = (id) => {
    dispatch(setLeaderboardId(id));
    getOverview(id);
  };

  const addNewLeaderboard = () => {
    setIsAddNewPopupOpen(true);
  };

  const closeAddNewCollection = () => {
    setIsAddNewPopupOpen(false);
  };
  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];
  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});
  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray?.map((data) => (
          <div key={data.id} className={selectedId === data.id ? classes.highlightItem : ''}>
            <ListItem
              key={data.id}
              button
              selected={selectedId === data.id}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data.id)}
              ref={myRefs[data.id]}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`
                      ${selectedId === data.id ? classes.listTextSelected : classes.listTextNonSelected}
                    `}
                    >
                      {data.name}
                    </p>
                  </div>
                }
                secondary={
                  <div>
                    <div
                      className={selectedId === data.id ? classes.listSubTextSelected : classes.listSubTextNonSelected}
                    >
                      <div className={classes.listSubTextJustify}>
                        <div>{`${data.dealershipCount || 0} dealerships`}</div>
                        <div className={!data.enabled ? classes.secondaryTextRed : null}>
                          {`${data.enabled ? 'Active' : 'Inactive'}`}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
      <FloatButton fabs={fabs} value={0} mainTabID={8} onAddNewLeaderboard={addNewLeaderboard} />
      {isAddNewPopupOpen && <LeaderboardAddNewPopup close={closeAddNewCollection} />}
      <ShowProgress />
    </div>
  );
};

export default SidebarLeaderboard;
